import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a5a866a2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-layout" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", { class: "content" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "container-fluid" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "card card-flex card-outline card-themes" }, [
      /*#__PURE__*/_createElementVNode("div", {
        class: "card-body table-responsive p-0 justify-content-center align-items-center",
        style: {"display":"inline-flex"}
      }, [
        /*#__PURE__*/_createElementVNode("h1", null, "欢迎使用")
      ])
    ])
  ])
], -1))

export function render(_ctx, _cache) {
  const _component_app_content_header = _resolveComponent("app-content-header")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_app_content_header),
    _hoisted_2
  ]))
}